import Cookies from 'cookies';

import { COOKIE_NAMES } from 'constants/cookiesNames';

export const readUtmCookie = (ctx: App.ReduxAppContext['ctx']) => {
  const cookiesContext = Cookies(ctx.req, ctx.res!);
  return ctx.req?.__WL__?.isWL ? '' : decodeURIComponent(cookiesContext.get(COOKIE_NAMES.utm) || '');
};
